<div class="lead-page">
  <div class="lead-shell">
    <div class="lead-header">
      <div class="lead-title">
        <h2>Demo Schedule</h2>
        <p>Review scheduled, completed, and cancelled ANPR demos.</p>
      </div>
    </div>

    <div class="lead-filters">
      <div class="lead-filter-field">
        <label>Search</label>
        <input [(ngModel)]="filters.search" placeholder="Customer / phone / notes" />
      </div>
      <div class="lead-filter-field">
        <label>Demo Date</label>
        <p-datepicker [(ngModel)]="filters.date" dateFormat="dd/mm/yy" [showIcon]="true" inputId="demo-filter-date"
          [showOnFocus]="true" [showButtonBar]="true" [readonlyInput]="true">
        </p-datepicker>
      </div>
      <div class="lead-filter-field">
        <label>Status</label>
        <select [(ngModel)]="filters.status">
          <option value="">All Status</option>
          <option *ngFor="let status of statuses" [value]="status[0]">{{ status[1] }}</option>
        </select>
      </div>
    </div>

    <div class="inline-actions">
      <button class="lead-btn-secondary" (click)="applyFilters()">Apply Filters</button>
      <button class="lead-btn-muted filter-reset-btn" (click)="resetFilters()">Reset</button>
    </div>

    <div class="lead-loading" *ngIf="loading">Loading demos...</div>

    <!-- <div class="lead-table-wrap" *ngIf="!loading"> -->
    <table class="responsive-table-wrapper" *ngIf="!loading">
      <thead>
        <tr>
          <th>Lead ID</th>
          <th>Customer</th>
          <th>Phone</th>
          <th>Demo Date & Time</th>
          <th>Demo Type</th>
          <th>Status</th>
          <th>Notes</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="!demos.length">
          <td colspan="8" class="lead-empty">No demos found.</td>
        </tr>
        <tr *ngFor="let demo of demos">
          <td>{{ demo.lead_id_display }}</td>
          <td>{{ demo.customer_name }}</td>
          <td>{{ demo.phone_number }}</td>
          <td>{{ demo.demo_datetime | date: 'dd/MM/yyyy HH:mm' }}</td>
          <td>{{ demo.demo_type }}</td>
          <td><span class="lead-status {{ demo.demo_status }}">{{ demo.demo_status }}</span></td>
          <td>{{ demo.demo_notes || '-' }}</td>
          <td class="table-actions-cell">
            <div class="table-actions">
              <button class="action-button bt-edit" (click)="openEdit(demo)" title="Edit Demo" aria-label="Edit Demo">
                <fa-icon [icon]="['fas', 'pen']"></fa-icon>
              </button>
              <button class="action-button bt-delete" (click)="openConfirmationDialog(demo)" title="Delete Demo"
                aria-label="Delete Demo">
                <span>
                  <fa-icon [icon]="['fas', 'trash']" class="fa-light"></fa-icon>
                </span>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- </div> -->

    <div class="footer">
      <div class="total-records">Total Records: {{ totalRecords }}</div>
      <div class="pagination-controls">
        <label for="demo-page-size">Records per page</label>
        <select id="demo-page-size" [(ngModel)]="pageSize" (change)="selectPageSize()">
            <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
        </select>
        <span>{{ currentPage }} / {{ totalPages }}</span>
        <button (click)="previous()" [disabled]="!previousPage" class="change-page" title="Previous page">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24">
            <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"
              d="m15 18-6-6 6-6" />
          </svg>
        </button>
        <button (click)="next()" [disabled]="!nextPage" class="change-page" title="Next page">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24">
            <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"
              d="m9 18 6-6-6-6" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="lead-modal-backdrop" *ngIf="showEditModal">
  <div class="lead-modal">
    <div class="lead-title">
      <h3>Edit Demo</h3>
      <p>{{ selectedDemo?.customer_name }}</p>
    </div>
    <div class="lead-form-grid">
      <div class="lead-form-field">
        <label>Demo Date & Time</label>
        <p-datepicker [(ngModel)]="demoForm.demo_datetime" dateFormat="dd/mm/yy" [showIcon]="true"
          inputId="demo-edit-datetime" [showOnFocus]="true" [showButtonBar]="true" [readonlyInput]="true"
          [showTime]="true" hourFormat="24">
        </p-datepicker>
      </div>
      <div class="lead-form-field">
        <label>Demo Type</label>
        <select [(ngModel)]="demoForm.demo_type">
          <option *ngFor="let type of demoTypes" [value]="type[0]">{{ type[1] }}</option>
        </select>
      </div>
      <div class="lead-form-field">
        <label>Demo Status</label>
        <select [(ngModel)]="demoForm.demo_status">
          <option *ngFor="let status of statuses" [value]="status[0]">{{ status[1] }}</option>
        </select>
      </div>
      <div class="lead-form-field" style="grid-column: 1 / -1;">
        <label>Demo Notes</label>
        <textarea [(ngModel)]="demoForm.demo_notes"></textarea>
      </div>
      <!-- <div class="lead-form-field">
        <label>
          <input type="checkbox" [(ngModel)]="demoForm.remind_one_hour_before" />
          Remind 1 hour before demo
        </label>
      </div> -->
      <div class="check">
        <input type="checkbox" [(ngModel)]="demoForm.remind_one_hour_before" />
        <span> Remind 1 hour before demo</span>
      </div>
    </div>
    <div class="inline-actions">
      <button class="lead-btn" (click)="saveDemo()">Save Demo</button>
      <button class="lead-btn-muted" (click)="showEditModal = false">Cancel</button>
    </div>
  </div>
</div>

<div *ngIf="showConfirmationDialog" class="confirmation-modal">
  <div class="modal-content">
    <div class="modal-header">
      <!-- <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10" stroke="#6A5ACD" stroke-width="2" fill="none"/>
        <path d="M9 12l2 2 4-4" stroke="#FFFFFF" stroke-width="2"/>
        </svg> -->
      <i class="bi bi-exclamation-triangle warning-icon"></i>
      <h3>Are You Sure?</h3>
    </div>
    <div class="modal-body">
      <p>Do you want to delete this demo? Confirm your choice below!</p>
    </div>
    <div class="modal-footer">
      <button (click)="deleteDemo()" class="confirm-btn modal-red">Yes, Proceed</button>
      <button (click)="closeConfirmationDialog()" class="cancel-btn cancel-btn-green">Cancel</button>
    </div>
  </div>
</div>